/*
 * @Author: luoxiaolei you@email.comyou@email.com
 * @Date: 2022-11-24 11:44:51
 * @LastEditors: luoxiaolei you@email.comyou@email.com
 * @LastEditTime: 2022-11-24 13:11:01
 * @FilePath: \ijx-portal-app-front\src\store\module\moneyData.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  namespaced: true,
  state: {
    moneyData: []
  },
  mutations: {
    SET_MONEY_DATA(state, moneyData) {
      state.moneyData = moneyData
    }
  }
}
